var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3319 8.66913V7.33579H15.2979C14.9792 3.82379 12.1772 1.02113 8.66522 0.703125V2.66912H7.33189V0.703125C3.81989 1.02113 1.01722 3.82379 0.699219 7.33579H2.66522V8.66913H0.699219C1.01789 12.1811 3.81989 14.9838 7.33189 15.3018V13.3358H8.66522V15.3018C12.1772 14.9831 14.9799 12.1811 15.2979 8.66913H13.3319ZM11.3319 8.66913H7.67855L4.39522 4.56512L5.43655 3.73179L8.31922 7.33579H11.3326L11.3319 8.66913Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.b0a8318dab37501f7146f790207b0844.svg";
export { ForwardRef as ReactComponent };